<div *ngIf="case" class="card shadow card-height detail-documents mb-4">
  <div class="card-header py-4">
    <div class="d-flex">
      <h1>{{ "CASES.single.documents.heading" | translate }}</h1>
    </div>
    <div class="d-flex get-files-btns">
      <button mat-raised-button class="ms-2 mt-2 primary-button"
              [matMenuTriggerFor]="actionsMenu">{{ 'SHARED.actions' | translate }}
      </button>
      <mat-menu #actionsMenu="matMenu">
        <button mat-menu-item
                [matMenuTriggerFor]="contractAndMandateDocsMenu">{{ 'CASES.single.documents.contract_and_mandate' | translate }}
        </button>
        <button mat-menu-item [matMenuTriggerFor]="sendDocsMenu">{{ 'SHARED.send' | translate }}</button>
        <button mat-menu-item *ngIf="advicePackVisible" [matMenuTriggerFor]="advicePack">
          {{ 'CASES.single.resend_advice_pack' | translate }}
        </button>
        <!-- Debt Cancellation -->
        <button mat-menu-item [matMenuTriggerFor]="debtCancellationRequestMenu" *ngIf="authUser.packager.master">
          {{ 'CASES.single.documents.debt_cancellation_request.action' | translate }}
        </button>
        <!--  Send debt exoneration -->
        <button mat-menu-item [matMenuTriggerFor]="debtExonerationMenu" *ngIf="authUser.packager.master">
          {{ 'CASES.single.documents.debt_exoneration.action' | translate }}
        </button>
        <!--  Signature verification -->
        <button *ngIf="case.client && (authUser.role_id === 5 || authUser.role_id === 1 || authUser.role_id === 2)"
                mat-menu-item (click)="verifySignature(case.client)">
          {{
            !case.client.signature_verified_at ?
              ("CASES.details.signature_verify" | translate) :
              ("CASES.details.view_signature" | translate)
          }}
        </button>
      </mat-menu>

      <mat-menu #contractAndMandateDocsMenu="matMenu">
        <a mat-menu-item [disabled]="!latestContract?.pdf_location" target="_blank"
           href="{{storageUrl + latestContract?.pdf_location}}"
           [title]="!latestContract?.pdf_location ?
          ('CASES.single.get_contract_button_disabled' | translate) :
           ('DOCUMENTS.get_contract' | translate)">
          {{ "DOCUMENTS.get_contract" | translate }}
        </a>
        <a mat-menu-item [disabled]="!latestContract?.redacted_pdf_location" target="_blank"
           href="{{storageUrl + latestContract?.redacted_pdf_location}}">
          {{ "DOCUMENTS.get_redacted_contract" | translate }}
        </a>
        <!--Get mandate button for single case-->
        <a mat-menu-item *ngIf="!case.joint_application" [disabled]="!latestContract?.mandate_location" target="_blank"
           href="{{storageUrl + latestContract?.mandate_location}}" [title]="!latestContract?.mandate_location ?
          ('CASES.single.mandates_button_disabled' | translate) : ('CASES.single.get_mandates' | translate)">
          {{ "CASES.single.get_mandates" | translate }}
        </a>
        <!--   Get mandate button for joint case   -->
        <a mat-menu-item *ngIf="case.joint_application" [disabled]="!latestContract?.mandate_location" target="_blank"
           href="{{storageUrl + latestContract?.mandate_location}}" [title]="!latestContract?.mandate_location ?
          ('CASES.single.mandates_button_disabled' | translate) :
           ('CASES.single.get_client_1_mandates' | translate)">
          {{ "CASES.single.get_client_1_mandates" | translate }}
        </a>
        <a mat-menu-item *ngIf="case.joint_application" [disabled]="!latestContract?.mandate_location_1" target="_blank"
           href="{{storageUrl + latestContract?.mandate_location_1}}" [title]="!latestContract?.mandate_location_1 ?
          ('CASES.single.mandates_button_disabled' | translate) :
           ('CASES.single.get_client_2_mandates' | translate)">
          {{ "CASES.single.get_client_2_mandates" | translate }}
        </a>
        <button [disabled]="!latestContract?.pdf_location" mat-menu-item
                [matMenuTriggerFor]="resignContractAndMandateMenu" *ngIf="authUser.id === 1 || authUser.id === 27 || authUser.id === 36 || authUser.id === 3 || authUser.id === 6 || authUser.id === 967
           || authUser.id === 235517|| authUser.id === 582 || authUser.id === 513023 || authUser.id === 34 || authUser.id === 26
           || authUser.role_id === 2 || authUser.id === 705239 || authUser.id === 211750 || authUser.id === 667649 || authUser.id === 406931 || authUser.id === 943956"
                [title]="!latestContract?.pdf_location ? ('DOCUMENTS.resign_contract_and_mandate_disabled' | translate) :
                   ('DOCUMENTS.resign_contract_and_mandate' | translate)">
          {{ "DOCUMENTS.resign_contract_and_mandate" | translate }}
        </button>
        <button [disabled]="!latestContract?.pdf_location" mat-menu-item
          [matMenuTriggerFor]="resignMandateMenu" *ngIf="authUser.id === 1 || authUser.id === 27 || authUser.id === 36 || authUser.id === 3 || authUser.id === 6 || authUser.id === 967
           || authUser.id === 235517|| authUser.id === 582 || authUser.id === 513023 || authUser.id === 34 || authUser.id === 26
           || authUser.role_id === 2 || authUser.id === 705239 || authUser.id === 211750 || authUser.id === 667649 || authUser.id === 406931 || authUser.id === 943956"
          [title]="!latestContract?.pdf_location ? ('DOCUMENTS.resign_mandate_disabled' | translate) :
                   ('DOCUMENTS.resign_mandate' | translate)">
          {{ "DOCUMENTS.resign_mandate" | translate }}
        </button>
        <button mat-menu-item
                *ngIf="authUser.id === 1 || authUser.id === 22 || authUser.id === 27 || authUser.id === 36 || authUser.id === 2497
             || authUser.id === 26 || authUser.id === 513023 || authUser.id ===  667646 || authUser.id === 667649 ||
             authUser.id === 2597 || authUser.id === 704999"
                [disabled]="regeneratingContract ||
           !((!case.joint_application && latestContract?.signature) || (case.joint_application && latestContract?.signature && latestContract?.signature_1))"
                (click)="regenerateContract()"
                [title]="!latestContract?.pdf_location ? ('DOCUMENTS.regenerate_contract_disabled' | translate) : ('DOCUMENTS.regenerate_contract' | translate)">
          {{ "CASES.single.regenerate_contract" | translate }}
        </button>
      </mat-menu>

      <mat-menu #sendDocsMenu="matMenu">
        <button [matMenuTriggerFor]="clientRoleMenu" mat-menu-item *ngIf="authUser.packager.master">
          {{ 'CASES.single.send_auto_de_concurso' | translate }}
        </button>
        <button [matMenuTriggerFor]="autoDeExoneracionMenu" mat-menu-item *ngIf="authUser.packager.master">
          {{ 'CASES.single.send_auto_de_exoneracion' | translate }}
        </button>
        <button mat-menu-item (click)="sendSignedContract()" *ngIf="authUser.packager.master">
          {{ 'CASES.single.send_signed_contract' | translate }}
        </button>
        <button mat-menu-item [matMenuTriggerFor]="sendDocumentStatusListMenu" *ngIf="authUser.packager.master">
          {{ 'CASES.single.send_document_status_list' | translate }}
        </button>
        <button mat-menu-item [matMenuTriggerFor]="requestAccountUnlockingMenu" *ngIf="authUser.packager.master">
          {{ 'CASES.single.request_account_unlocking.heading' | translate }}
        </button>
      </mat-menu>

      <mat-menu #clientRoleMenu="matMenu">
        <button mat-menu-item (click)="sendAutoDeConscursoDoc('client')" [disabled]="!autoDeConcursoUploaded">
          <span>{{ 'CASES.single.send_to_client' | translate }} 1</span>
        </button>
        <button mat-menu-item (click)="sendAutoDeConscursoDoc('partner')" *ngIf="authUser.packager.master"
                [disabled]="!case.joint_application || !autoDeConcursoUploaded">
          <span>{{ 'CASES.single.send_to_client' | translate }} 2</span>
        </button>
      </mat-menu>

      <mat-menu #autoDeExoneracionMenu="matMenu">
        <button mat-menu-item (click)="sendAutoDeExoneracionDoc('client')"
                [disabled]="!autoDeExoneracionUploadedClient">
          <span>{{ 'CASES.single.send_to_client' | translate }} 1</span>
        </button>
        <button mat-menu-item (click)="sendAutoDeExoneracionDoc('partner')"
                [disabled]="!case.joint_application || !autoDeExoneracionUploadedPartner">
          <span>{{ 'CASES.single.send_to_client' | translate }} 2</span>
        </button>
      </mat-menu>

      <mat-menu #sendDocumentStatusListMenu="matMenu">
        <button mat-menu-item (click)="sendDocumentStatusList('client')" [disabled]="!sendDocumentStatusListEnabled">
          <span>{{ 'CASES.single.send_to_client' | translate }} 1</span>
        </button>
        <button mat-menu-item (click)="sendDocumentStatusList('partner')" [disabled]="!sendDocumentStatusListEnabled">
          <span>{{ 'CASES.single.send_to_client' | translate }} 2</span>
        </button>
      </mat-menu>

      <mat-menu #resignContractAndMandateMenu="matMenu" class="resignContractAndMandateMenu" xPosition="after">
        <a mat-menu-item (click)="resignContractAndMandate($event, 'email', 'client', true, true)" href="#"> Client Email</a>
        <a mat-menu-item (click)="resignContractAndMandate($event, 'sms', 'client', true, true)" href="#"> Client SMS</a>
        <a mat-menu-item (click)="resignContractAndMandate($event, 'all', 'client', true, true)" href="#"> Client Email & SMS</a>
        <a *ngIf="case.joint_application"
           mat-menu-item (click)="resignContractAndMandate($event, 'email', 'partner', true, true)" href="#"> Client 2 Email</a>
        <a *ngIf="case.joint_application"
           mat-menu-item (click)="resignContractAndMandate($event, 'sms', 'partner', true, true)" href="#"> Client 2 SMS</a>
        <a *ngIf="case.joint_application"
           mat-menu-item (click)="resignContractAndMandate($event, 'all', 'partner', true, true)" href="#"> Client 2 Email &
          SMS</a>
      </mat-menu>

      <mat-menu #resignMandateMenu="matMenu" class="resignMandate" xPosition="after">
        <a mat-menu-item (click)="resignContractAndMandate($event, 'email', 'client', false, true)" href="#"> Client Email</a>
        <a mat-menu-item (click)="resignContractAndMandate($event, 'sms', 'client', false, true)" href="#"> Client SMS</a>
        <a mat-menu-item (click)="resignContractAndMandate($event, 'all', 'client', false, true)" href="#"> Client Email & SMS</a>
        <a *ngIf="case.joint_application" mat-menu-item (click)="resignContractAndMandate($event, 'email', 'partner', false, true)" href="#"> Client 2 Email</a>
        <a *ngIf="case.joint_application" mat-menu-item (click)="resignContractAndMandate($event, 'sms', 'partner', false, true)" href="#"> Client 2 SMS</a>
        <a *ngIf="case.joint_application" mat-menu-item (click)="resignContractAndMandate($event, 'all', 'partner', false, true)" href="#"> Client 2 Email & SMS</a>
      </mat-menu>

      <mat-menu #advicePack="matMenu">
        <button mat-menu-item (click)="resendAdvicePackEmail(true)">
          <span>{{ 'CASES.single.generate' | translate }}</span>
        </button>
        <button mat-menu-item (click)="resendAdvicePackEmail(false)">
          <span>{{ 'CASES.single.dont_generate' | translate }}</span>
        </button>
      </mat-menu>

      <mat-menu #debtCancellationRequestMenu="matMenu">
        <a mat-menu-item [routerLink]="['/client/sign-debt-cancellation-request']" target="_blank"
           [queryParams]="{uuid: case.uuid, type: 'debt-cancellation-request', sign: 'client'}">
          {{ 'CASES.single.documents.debt_cancellation_request.preview' | translate }} 1
        </a>
        <a mat-menu-item [routerLink]="['/client/sign-debt-cancellation-request']" target="_blank"
           [queryParams]="{uuid: case.uuid, type: 'debt-cancellation-request', sign: 'partner'}">
          {{ 'CASES.single.documents.debt_cancellation_request.preview' | translate }} 2
        </a>
        <button mat-menu-item (click)="requestDebtCancellationRequestSignature('client')">
          {{ 'CASES.single.documents.debt_cancellation_request.request_signature.action' | translate }} 1
        </button>
        <button mat-menu-item (click)="requestDebtCancellationRequestSignature('partner')">
          {{ 'CASES.single.documents.debt_cancellation_request.request_signature.action' | translate }} 2
        </button>
        <button mat-menu-item (click)="sendEmailToExperian()" [disabled]="!areExperianAttachmentsReady">
          {{ 'CASES.single.documents.debt_cancellation_request.send_email_to_experian' | translate }}
        </button>
      </mat-menu>

      <mat-menu #debtExonerationMenu="matMenu">
        <a mat-menu-item [routerLink]="['/public/sign-debt-exoneration']" target="_blank"
           [queryParams]="{uuid: case.uuid, sign: ''}">
          {{ 'CASES.single.documents.debt_exoneration.preview' | translate }}
        </a>
        <button mat-menu-item (click)="requestDebtExonerationSignature('sms')">
          {{ 'CASES.single.documents.debt_exoneration.request_signature.action_sms' | translate }}
        </button>
        <button mat-menu-item (click)="requestDebtExonerationSignature('email')">
          {{ 'CASES.single.documents.debt_exoneration.request_signature.action_email' | translate }}
        </button>
        <a mat-menu-item href="{{storageUrl + debtExonerationDocument?.files[0]?.path}}"
           [disabled]="!debtExonerationDocument?.files[0]?.path">
          {{ 'CASES.single.documents.debt_exoneration.download' | translate }}
        </a>
      </mat-menu>

      <mat-menu #requestAccountUnlockingMenu="matMenu">
        <button mat-menu-item (click)="openRequestAccountUnlocking('client')">
          <span>{{ 'CASES.single.send_to_client' | translate }} 1</span>
        </button>
        <button mat-menu-item (click)="openRequestAccountUnlocking('partner')">
          <span>{{ 'CASES.single.send_to_client' | translate }} 2</span>
        </button>
      </mat-menu>
    </div>
  </div>
  <router-outlet></router-outlet>
</div>
